import { render } from "./TestData.vue?vue&type=template&id=4c536d9a"
import script from "./TestData.vue?vue&type=script&lang=js"
export * from "./TestData.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/OpenMCT/OpenMCT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__